import type { SVGProps } from "react";
export interface TreesIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function TreesIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: TreesIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M14.275 22v-2.88q-.039.003-.079.004h-4.07V22a1.125 1.125 0 0 1-2.25 0v-2.876H3.001c-1.683 0-2.699-1.864-1.786-3.278l2.19-3.391-.032-.006a1.626 1.626 0 0 1-.974-2.61l1.856-2.334a1.624 1.624 0 0 1-.218-2.27l2.909-3.576.168-.183c.82-.8 2.14-.8 2.96 0l.17.183.049.061a1.124 1.124 0 0 1-1.696 1.475L6.386 5.913l.011.004a1.127 1.127 0 0 1 .58 1.784l-2.17 2.726.66.123a1.125 1.125 0 0 1 .74 1.716L3.23 16.874h10.966c.222 0 .428.067.602.177a1.126 1.126 0 0 1 1.727.95V22a1.126 1.126 0 0 1-2.25 0"
      />
      <path
        fill={color}
        d="M13.92 1.48c.82-.8 2.14-.8 2.96 0l.168.183 2.91 3.574.124.176a1.625 1.625 0 0 1-.344 2.094l1.857 2.334.128.184a1.627 1.627 0 0 1-.884 2.37l-.218.056-.03.005 2.194 3.39c.915 1.413-.1 3.28-1.785 3.28H9.8c-1.684 0-2.7-1.867-1.784-3.28l2.192-3.39-.029-.005a1.626 1.626 0 0 1-.974-2.61l1.856-2.334a1.624 1.624 0 0 1-.218-2.27l2.909-3.574zm-.73 4.437.012.004a1.125 1.125 0 0 1 .578 1.784l-2.168 2.723.66.123a1.126 1.126 0 0 1 .74 1.719l-2.983 4.605H20.77l-2.982-4.605a1.126 1.126 0 0 1 .738-1.719l.66-.123-2.167-2.723a1.126 1.126 0 0 1 .579-1.784l.01-.004-2.21-2.715z"
      />
    </svg>
  );
}
